import type { FaireProductEntity } from "../../entity_types/product";

export const p_ctba4dksfe: FaireProductEntity = {
  token: "p_ctba4dksfe",
  type: "product",
  name: "MID STREET - Split Toe Ballet Flat ✈️SHIPS TODAY",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/2cdc8c98fbe540fcbf32b7cd9b64b50626154b9e7c34e06427b82ac34d8ea492.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e54d4085332f6bdf00f1989ac39502430d72025d2c3d36a4373d742593ae05c.jpeg",
    "https://cdn.faire.com/fastly/ccecaf3098fe582af9b92755f5d882457e4f5f96c6055e85bd4e20eb09e5d6a5.jpeg",
    "https://cdn.faire.com/fastly/a72d808258e5cf6c1b290f0ce5f2a4fe10c8938b1c75c858a23aa471eb837150.jpeg",
    "https://cdn.faire.com/fastly/d60e8e7622f4d069f4c7dcd811086c65aec68ad0e315b22e0440040d232514af.jpeg",
    "https://cdn.faire.com/fastly/5733242431767e1f5e0f078e4d1f909e790563ef2688094bffba163e9485c18c.jpeg",
    "https://cdn.faire.com/fastly/ef4d9cef19b2f7f898d8b941608535252d6a7e14ed0f9513afc17549c12fb583.jpeg",
    "https://cdn.faire.com/fastly/c7cc14ce87c8c30720d5367a9cb9fffc3e976ae8d6307b9ed525723632dbfd7e.jpeg",
    "https://cdn.faire.com/fastly/0d1181743fb1512d24c49f05591a197d322b5d51480b158cd283df4a6a6d9d6e.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg",
  ],
  priceDollars: 13.25,
  description:
    "MID STREET is a modern take on the classic ballet flat, this style features a distinctive split-toe, tabby silhouette paired with a soft, minimalist upper for an effortlessly fashion-forward feel. The delicate bow detail adds a subtle feminine touch, while the flexible construction keeps it comfortable for everyday wear. Equal parts sleek and understated, this flat blends contemporary design with timeless versatility, making it an easy addition to any wardrobe.\n\nAvailable in Black, Camel, Cream, and Pink.\nOOTD\nStyle these flats with relaxed denim and a fitted tee for an easy everyday look, or pair them with a flowy midi skirt and lightweight knit for a softer, ballet-inspired outfit. Add a structured bag and minimal jewelry to keep the look polished while letting the unique split-toe detail stand out.",
  tags: [],
  msrpDollars: 26.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:15.534Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
